module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASTER OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PACE AND")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IME")])])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Published by"), _c('br'), _vm._v("Thunder’s Mouth Press"), _c('br'), _vm._v("An Imprint of Avalon Publishing Group Inc."), _c('br'), _vm._v("245 West 17th St., 11th Floor"), _c('br'), _vm._v("New York, NY 10011")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/copy.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Copyright © 1984 by Rudy Rucker")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("First Thunder’s Mouth Press edition April 2005")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("All rights reserved. No part of this publication may be reproduced"), _c('br'), _vm._v("or transmitted in any form or by any means, electronic or mechanical,"), _c('br'), _vm._v("including photocopy, recording, or any information storage and retrieval"), _c('br'), _vm._v("system now known or to be invented, without permission in writing"), _c('br'), _vm._v("from the publisher, except by a reviewer who wishes to quote brief"), _c('br'), _vm._v("passages in connection with a review written for inclusion in a"), _c('br'), _vm._v("magazine, newspaper or broadcast.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Library of Congress Cataloging-in-Publication Data is available.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("ISBN 1-56025-703-2")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("10  9  8  7  6  5  4  3  2  1")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Book design by Terry McCabe"), _c('br'), _vm._v("Distributed by Publishers Group West")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-851a313e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 66
// module chunks = 0